import {
  clearCompanyCreator,
  clearPleskConnection,
  setCompanyCreator,
  showMongoConnection,
  showPleskConnection,
  clearMongoConnection,
  showRepositoryConnection,
  clearRepositoryConnection,
} from './modalsSlice';

export const showCompanyCreatorModal = (companyData) => {
  return async (dispatch) => {
    dispatch(setCompanyCreator({ companyData }));
  };
};

export const hideCompanyCreatorModal = () => {
  return async (dispatch) => {
    dispatch(clearCompanyCreator());
  };
};

export const showConnectionPlesk = (selected, data) => {
  return (dispatch) => {
    dispatch(
      showPleskConnection({
        pleskConnections: {
          visibility: true,
          selected,
          data,
        },
      })
    );
  };
};

export const hideConnetionPlesk = () => {
  return async (dispatch) => {
    dispatch(clearPleskConnection());
  };
};

export const showConnectionMongodb = (selected, data) => {
  return (dispatch) => {
    dispatch(
      showMongoConnection({
        databases: {
          visibility: true,
          selected,
          data,
        },
      })
    );
  };
};

export const hideConnetionMongodb = () => {
  return async (dispatch) => {
    dispatch(clearMongoConnection());
  };
};

export const showConnectionRepository = (selected, data) => {
  return (dispatch) => {
    dispatch(
      showRepositoryConnection({
        gitVersions: {
          visibility: true,
          selected,
          data,
        },
      })
    );
  };
};

export const hideConnetionRepository = () => {
  return async (dispatch) => {
    dispatch(clearRepositoryConnection());
  };
};
